module.exports = __webpack_public_path__ + "img/ship_interior.d8ec6426.jpg";